module.exports = __webpack_public_path__ + "img/v1.1.c26caee4.jpg";